<template>
  <v-app>
    <v-main class="grey lighten-4 app testlock aaa">
      <router-view />
    </v-main>
    <snackbar></snackbar>
    <Footer></Footer>
    <PrintPreview />
  </v-app>
</template>

<style>
@import url("https://fonts.googleapis.com/css?family=Prompt:100,100italic,200,200italic,300,300italic,regular,italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic");
@import url('https://fonts.googleapis.com/css2?family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');
* {
  font-family: Prompt;
  /* font-weight: 400; */
}
.app {
  font-weight: 500;
}
</style>

<script>
import socket from "@/mixins/socket.js";
import store from "./store/index";
import Footer from "./components/Footer";
import Snackbar from "./components/Snackbar";
import PrintPreview from "./components/PrintPreview";
export default {
  components: { Footer, Snackbar, PrintPreview },
  name: "App",
  store,
  mixins: [socket],
};
</script>
